export const stats = {
  adrcCount: 36,
  exploratoryCount: 0,
  studyCount: "1,450+",
  clinicalCount: "200,000+",
  neuropathCount: "8,300+",
  participantCount: "54,000+",
  activeParticipantCount: "20,000+",
};
